import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import { currencyFormatter } from "../../utils/Utils";

export default function OrderDetails({ order }) {
  const details = {
    // "No.": order.no,
    "Order Date": order.orderDate,
    "Est. Despatch": "TBA",
    Status: order.status === "Open" ? "In Progress" : "Part Shipped",
    Total: currencyFormatter(order.currencyCode, order.amount || 0),
    "Total inc. VAT": currencyFormatter(
      order.currencyCode,
      order.amountInclVat || 0,
    ),
    Reference: order.yourReference,
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Details
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, md: 2 }}
        columns={{ xs: 2, sm: 2, md: 3 }}
      >
        {Object.entries(details).map(([key, value], i) => (
          <Grid
            key={key}
            size={{
              xs: 1,
              sm: 1,
              md: 1,
            }}
          >
            <TextField
              size="small"
              fullWidth
              id={`${key}-input`}
              label={key}
              value={value || ""}
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
